import { render } from "./PosterCardSkeleton.vue?vue&type=template&id=13e19b67&ts=true"
import script from "./PosterCardSkeleton.vue?vue&type=script&lang=ts"
export * from "./PosterCardSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__